import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import "firebase/storage"

const config = {
  apiKey: "AIzaSyBvnYW88nH6Ca6uptFCfz_-u8iAkrOpHyI",
  authDomain: "grouptravelres.firebaseapp.com",
  databaseURL: "https://grouptravelres.firebaseio.com",
  projectId: "grouptravelres",
  storageBucket: "grouptravelres.appspot.com",
  messagingSenderId: "197354597279",
  appId: "1:197354597279:web:5ee3755e1155769900abaa",
  measurementId: "G-P7MW47J2R3",
}

if (!firebase.apps.length) {
  firebase.initializeApp(config)
  firebase?.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
}

export default firebase

firebase
  .firestore()
  .enablePersistence()
  .catch((err) => {
    if (err.code == "failed-precondition") {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // ...
    } else if (err.code == "unimplemented") {
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
    }
  })

export const db = firebase.firestore()
export const storage = firebase.storage()

// const FOLDER = "TEST"
const FOLDER = "IMAGES"

export const removeFile = (name) => {
  const storageRef = storage.ref()
  const ref = storageRef.child(`${FOLDER}${name}`)
  return ref.delete()
}

export const upload = ({ file, metadata }, cb) =>
  new Promise((resolve, reject) => {
    // uploadTask.pause()
    // uploadTask.resume()
    // uploadTask.cancel()
    // "test/" + metadata.name

    const ID = Math.random().toString(36).substr(2, 9)
    // ${ID}-
    const NAME = `${file.name}`
    const path = `${FOLDER}/${NAME}`
    const storageRef = firebase.storage().ref()
    const uploadTask = storageRef.child(path).put(file, metadata)

    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        cb(progress)

        // switch (snapshot.state) {
        //   case firebase.storage.TaskState.PAUSED: // or 'paused'
        //     break
        //   case firebase.storage.TaskState.RUNNING: // or 'running'
        //     break
        // }
      },
      (error) => {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case "storage/unauthorized":
            // User doesn't have permission to access the object
            break

          case "storage/canceled":
            // User canceled the upload
            break

          case "storage/unknown":
            // Unknown error occurred, inspect error.serverResponse
            break
        }
      },
      async () => {
        const url = await uploadTask.snapshot.ref.getDownloadURL()
        resolve({ ...metadata, url })
      },
    )
  })
